
<div class="page-title mb-3">
    <h1>
        Campaign Dashboard: 
        <span class="font-light">{{model.selectedCampaign()?.name}}</span>
    </h1>
</div>


<div class="dashboard-grid mb-5">
    <div id="total-raised" class="dashboard-widget-container">
        <div class="dashboard-widget border-red">
            <h3>Total Raised</h3>
            <div class="widget-content my-4">

                <div *ngIf="data === null" class="flex flex-column align-items-center">
                    <p-skeleton width="5rem" height="3rem" styleClass="mb-2" />
                    <p-skeleton width="10rem" styleClass="mb-2" />
                </div>

                <div *ngIf="data !== null">
                    <div class="report-amount">
                        <sup class="dollar-sign">$</sup>
                        <span *ngIf="data?.totalRaiseByCampaign?.length > 0">{{formatTotal(data?.totalRaiseByCampaign[0].total)}}</span>
                        <span *ngIf="data?.totalRaiseByCampaign?.length === 0">0</span>
                    </div>
                    <div *ngIf="data?.totalRaiseByCampaign?.length > 0">
                        ($<span [innerHTML]="toMoneyDisplay(data?.totalRaiseByCampaign[0].total, false)"></span>)
                    </div>
                    <!-- if entity campaign -->
                    <div class="entity-amounts-list">
                        <ul>
                            <li *ngFor="let item of data?.totalRaiseByChildCampaign">
                                <span [innerText]="item?.childCampaign || 'Other'"></span>
                                <span [innerText]="toMoneyDisplay(item.total, true)"></span>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
        </div>
    </div>



    <div id="top-event-codes" class="dashboard-widget-container">
        <div class="dashboard-widget">
            <h3>Top Event Codes</h3>
            <div class="widget-content">

                <div *ngIf="data === null">
                    <ul class="m-0 p-0 list-none">

                        <li class="mb-3">
                            <div class="flex">
                                <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
                                <div style="flex: 1">
                                    <p-skeleton width="7rem" styleClass="mb-2" />
                                    <p-skeleton width="3rem" />
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="flex">
                                <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
                                <div style="flex: 1">
                                    <p-skeleton width="7rem" styleClass="mb-2" />
                                    <p-skeleton width="3rem" />
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="flex">
                                <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
                                <div style="flex: 1">
                                    <p-skeleton width="7rem" styleClass="mb-2" />
                                    <p-skeleton width="3rem" />
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="flex">
                                <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
                                <div style="flex: 1">
                                    <p-skeleton width="7rem" styleClass="mb-2" />
                                    <p-skeleton width="3rem" />
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="flex">
                                <p-skeleton shape="circle" size="2rem" styleClass="mr-2" />
                                <div style="flex: 1">
                                    <p-skeleton width="7rem" styleClass="mb-2" />
                                    <p-skeleton width="3rem" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                
                <div *ngIf="data !== null">
                    <ul class="event-code-list list-none" *ngIf="data?.topEventCodesByCampaign?.length; else noChartBlock">
                        <li *ngFor="let item of data?.topEventCodesByCampaign">
                            <span class="event-code" [innerText]="item?.campaign || 'Other'"></span>
                            <span class="event-raised-amount" [innerText]="toMoneyDisplay(item.total, true)"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>



    <div id="raised-by-source" class="dashboard-widget-container">
        <div class="dashboard-widget">
            <h3>Raised by Source</h3>
            <div class="widget-content">
                <div *ngIf="data === null">
                    <p-skeleton width="10rem" height="5rem" styleClass="mb-2" />
                </div>

                <div *ngIf="data !== null">
                    <div *ngIf="raiseBySourceTotals.length > 0; else noChartBlock">
                        <div style="width: 100%; max-width: 25rem;">
                            <rc-bar-chart 
                                [labels]="raiseBySourceTitles" 
                                [data]="raiseBySourceTotals" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>



    <div id="compliance-actions" class="dashboard-widget-container">
        <div class="dashboard-widget">
            <h3>Compliance Actions</h3>
            <div class="widget-content my-4">

                <div *ngIf="data === null">
                    <p-skeleton styleClass="mb-2" width="7rem" height="3rem" />
                </div>

                <div *ngIf="data !== null">
                    <div class="report-amount compliance-needed" *ngIf="data?.complianceNeededByCampaign?.length && shouldShowData(data?.complianceNeededByCampaign[0]);">
                        <sup class="dollar-sign">$</sup>
                        <span [innerHTML]="data?.complianceNeededByCampaign?.length && toMoneyDisplay(data?.complianceNeededByCampaign[0]?.total, false)"></span>
                    </div>

                    <div class="report-amount compliance-not-needed" *ngIf="data?.complianceNeededByCampaign?.length === 0">
                        <sup class="dollar-sign">$</sup>
                        <span>0</span>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div id="raised-by-event-type" class="dashboard-widget-container">
        <div class="dashboard-widget">
            <h3>Raised by Event Type</h3>
            <div class="widget-content">
                <div *ngIf="data === null" style="width: 100%; max-width: 25rem; aspect-ratio: 1/0.7;" class="flex justify-content-center align-items-center">
                    <p-skeleton shape="circle" width="10rem" height="10rem" />
                </div>
                <div *ngIf="data !== null" style="width: 100%; max-width: 25rem;" class="flex justify-content-center align-items-center">
                    <div *ngIf="raiseByEventTypeByCampaignTotals.length > 0; else noChartBlock">
                        <rc-pie-chart
                            [labels]="raiseByEventTypeByCampaignTitles" 
                            [data]="raiseByEventTypeByCampaignTotals" 
                            />
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div id="campaign-stats" class="dashboard-widget-container">
        <div class="dashboard-widget">
            <h3>Campaign Stats</h3>
            <div class="widget-content">
                <div *ngIf="data === null" class="full-width flex justify-content-evenly align-items-center my-3">
                    <p-skeleton width="5rem" height="2rem" />
                    <p-skeleton width="5rem" height="2rem" />
                    <p-skeleton width="5rem" height="2rem" />
                </div>

                <div *ngIf="data !== null" class="full-width flex justify-content-evenly align-items-end mt-2 mb-3 gap-3 px-2">
                    <div>
                        <span class="h3 redwood-80 font-light">Donors</span>
                        <span class="report-amount" 
                            [innerHtml]="toThousandsDisplay(data?.numberOfDonorsByCampaign[0]?.total)" 
                            *ngIf="data?.numberOfDonorsByCampaign?.length > 0 && shouldShowData(data?.numberOfDonorsByCampaign)"></span>
                        <span class="report-amount" 
                            *ngIf="data?.numberOfDonorsByCampaign?.length === 0 && shouldShowData(data?.numberOfDonorsByCampaign)">0</span>
                    </div>

                    <div>
                        <span class="h3 redwood-80 font-light">Average Donation</span>
                        <span class="report-amount" *ngIf="data?.averageDonationAmountByCampaign?.length > 0 && shouldShowData(data?.averageDonationAmountByCampaign[0])">
                            <span class="dollar-sign">$</span>
                            <span [innerText]="">{{toMoneyDisplay(data?.averageDonationAmountByCampaign[0].amount, false)}}</span>
                        </span>
                        <span class="report-amount" *ngIf="data?.averageDonationAmountByCampaign?.length === 0 && shouldShowData(data?.averageDonationAmountByCampaign[0])">
                            <span class="dollar-sign">$</span>
                            <span>0</span>
                        </span>
                    </div>

                    <div>
                        <span class="h3 redwood-80 font-light">Donations</span>
                        <span class="report-amount"
                            *ngIf="data?.numberOfDonorsByCampaign?.length > 0 && shouldShowData(data?.numberOfDonationsByCampaign);"
                            [innerText]="toThousandsDisplay(data?.numberfOfDonationsByCampaign[0]?.total)"></span>
                        <span class="report-amount"
                            *ngIf="data?.numberOfDonorsByCampaign?.length === 0 && shouldShowData(data?.numberOfDonationsByCampaign);">0</span>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>





<div class="grid">
    <div class="col-12 xxl:col-4">
        <p-card id="total-spent" styleClass="card-style-donor">
            <ng-template pTemplate="header">
                <p>Total Spent</p>
            </ng-template>

            <div class="grid">
                <div class="col-12 md:col-6 xxl:col-12 flex justify-content-center align-items-center flex-column my-5">
                    <div *ngIf="data === null" class="full-width flex flex-column align-items-center my-3">
                        <p-skeleton width="5rem" height="2rem" styleClass="mb-2" />
                        <p-skeleton width="7rem" height="1rem" />
                    </div>

                    <div *ngIf="data !== null && data?.totalSpendByCampaign?.length > 0">
                        <div class="report-amount">
                            <sup class="dollar-sign">$</sup>
                            <span [innerHTML]="formatTotal(data?.totalSpendByCampaign[0].total)"></span>
                        </div>
                    </div>

                    <div *ngIf="data?.totalSpendByCampaign?.length > 0" class="my-2" style="width: 100%; text-align: center;">
                        ($<span [innerHTML]="toMoneyDisplay(data?.totalSpendByCampaign[0].total, false)"></span>)
                    </div>

                    <div *ngIf="data !== null && data?.totalSpendByCampaign?.length === 0">
                        <div class="report-amount">
                            <sup class="dollar-sign">$</sup>
                            <span>0</span>
                        </div>
                    </div>
                </div>

                <!-- if regular campaign - show pie chart -->
                <div class="col-12 md:col-6 xxl:col-12 flex justify-content-center align-items-center" *ngIf="data && !model.selectedCampaign()?.isEntity">

                    <div style="width: 100%; max-width: 25rem;" class="flex justify-content-center align-items-center" *ngIf="data?.totalSpendByCampaign?.length && data.totalRaiseByCampaign[0]?.total; else noChartBlock" >
                        <rc-pie-chart
                            [options]="totalSpendDonutChartOptions"
                            [colors]="['#8C261D','#E0D1CE']"
                            [labels]="['Raised: '+ toMoneyDisplay(data.totalRaiseByCampaign[0].total), 'Spent: ' + toMoneyDisplay(data.totalSpendByCampaign[0].total)]" 
                            [data]="[data.totalSpendByCampaign[0].total, data.totalRaiseByCampaign[0].total - data.totalSpendByCampaign[0].total]" 
                            wid
                            />
                    </div>  
                </div>

                <!-- if entity campaign - list of expenses by child campaign INSTEAD of the chart -->
                <div class="col-12 md:col-6 xxl:col-12 flex justify-content-center align-items-center" *ngIf="data && model.selectedCampaign()?.isEntity">

                    <div class="entity-amounts-list">
                        <ul>
                            <li *ngFor="let item of data?.totalSpendByChildCampaign">
                                <span [innerText]="item?.childCampaign || 'Other'"></span>
                                <span [innerText]="toMoneyDisplay(item.total, true)"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </p-card>
    </div>

    <div class="col-12 md:col-6 xxl:col-4">
        <p-card id="spent-by-vendor" styleClass="card-style-donor">
            <ng-template pTemplate="header">
                <p>Spent by Vendor</p>
            </ng-template>
            
            <div>
                <div *ngIf="data === null">
                    <p-skeleton width="100%" height="20rem" styleClass="mb-2" />
                </div>
                
                <div *ngIf="data !== null">
                    <div *ngIf="data.spendByVendorByCampaign?.length; else noDataBlock">
                        <p-table 
                            [value]="data.spendByVendorByCampaign" 
                            styleClass="p-datatable-striped" 
                            [rows]="10"
                            sortField="total" 
                            [sortOrder]="-1"
                            [scrollable]="true" 
                            [paginator]="true"
                            [rows]="10"
                            [rowsPerPageOptions]="[10, 25, 50, 100]" 
                            scrollHeight="flex"
                            *ngIf="data?.spendByVendorByCampaign?.length">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="title">Vendor</th>
                                    <th pSortableColumn="total" style="text-align: right;">Total</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td>{{ product.title }}</td>
                                    <td style="text-align: right;">{{ toMoneyDisplay(product.total) }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </p-card>
    </div>

    <div class="col-12 md:col-6 xxl:col-4">
        <p-card id="spent-by-gl" styleClass="card-style-donor">
            <ng-template pTemplate="header">
                <p>Spent by GL</p>
            </ng-template>
            <div>
                <div *ngIf="data === null">
                    <p-skeleton width="100%" height="20rem" styleClass="mb-2" />
                </div>
                
                <div *ngIf="data !== null">
                    <div *ngIf="data.spendByGlaccountByCampaign?.length; else noDataBlock">
                        <p-table 
                            [value]="data.spendByGlaccountByCampaign" 
                            styleClass="p-datatable-striped" 
                            sortField="total" 
                            [sortOrder]="-1"
                            [scrollable]="true" 
                            scrollHeight="flex"
                            [paginator]="true"
                            [rows]="10"
                            [rowsPerPageOptions]="[10, 25, 50, 100]" 
                            *ngIf="data?.spendByGlaccountByCampaign?.length">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="title">GL Account</th>
                                    <th pSortableColumn="total" style="text-align: right;">Total</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td>{{ product.title }}</td>
                                    <td style="text-align: right;">{{ toMoneyDisplay(product.total) }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </p-card>
    </div>

</div>

<ng-template #noDataBlock>
    <i class="my-2 text-center block neutral-50">
        No Data Available
    </i>
</ng-template>

<ng-template #noChartBlock>
    <div class="flex flex-column justify-content-center align-items-center m-3">
        <i class="fa-sharp fa-light fa-magnifying-glass-chart fa-3x neutral-30"></i>
        <i class="neutral-50 mt-3">No Data Available</i>
    </div>
</ng-template>